/* RHÔME — composeur de pack
   Le client choisit N produits dans une collection, puis les ajoute
   d'un coup au panier. La remise automatique Shopify fait le reste.
   Chaque ligne ajoutée porte une propriété « Pack » pour que la commande
   indique clairement de quelle offre elle provient. */
(function () {
  'use strict';

  function init(root) {
    var slotsCount = parseInt(root.getAttribute('data-slots'), 10) || 3;
    var dataEl = root.querySelector('[data-rh-bundle-products]');
    if (!dataEl) return;

    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }

    /* libellé du pack, pour la propriété de ligne */
    function packLabel() {
      var attr = root.getAttribute('data-pack-label');
      if (attr) return attr;
      var h1 = document.querySelector('[data-rh-pdp] h1');
      if (h1 && h1.textContent.trim()) return h1.textContent.trim();
      var h2 = root.querySelector('.rh-bundle__card h2');
      if (h2 && h2.textContent.trim()) return h2.textContent.trim();
      return 'Pack';
    }

    var chosen = new Array(slotsCount).fill(null);
    var current = 0;

    var modal = root.querySelector('[data-rh-pickmodal]');
    var list = root.querySelector('[data-rh-picklist]');
    var countEl = root.querySelector('[data-rh-count]');
    var barEl = root.querySelector('[data-rh-bar]');
    var cta = root.querySelector('[data-rh-bundleadd]');

    function openPicker(i) {
      current = i;
      modal.classList.add('is-on');
      document.body.style.overflow = 'hidden';
    }
    function closePicker() {
      modal.classList.remove('is-on');
      document.body.style.overflow = '';
    }

    function render() {
      var filled = 0;
      chosen.forEach(function (c, i) {
        var slot = root.querySelector('[data-slot="' + i + '"]');
        if (!slot) return;
        var btn = slot.querySelector('.rh-bundle__btn');
        var lbl = slot.querySelector('.rh-bundle__lbl');
        var rm = slot.querySelector('.rh-bundle__rm');
        if (c) {
          filled++;
          slot.classList.add('is-filled');
          btn.innerHTML = '<img src="' + c.img + '" alt="">';
          lbl.textContent = c.title;
          if (rm) rm.hidden = false;
        } else {
          slot.classList.remove('is-filled');
          btn.textContent = '+';
          lbl.textContent = 'Ajouter';
          if (rm) rm.hidden = true;
        }
      });
      if (countEl) countEl.textContent = filled;
      if (barEl) barEl.style.width = (filled / slotsCount * 100) + '%';
      if (cta) cta.disabled = filled < slotsCount;
    }

    /* liste des produits */
    products.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rh-bundle__item' + (p.available ? '' : ' is-out');
      btn.innerHTML =
        '<img src="' + p.img + '" alt="" loading="lazy">' +
        '<b>' + p.title + '</b>' +
        '<span>' + (p.available ? p.price : 'Épuisé') + '</span>';
      if (p.available) {
        btn.addEventListener('click', function () {
          chosen[current] = p;
          render();
          closePicker();
          /* enchaine sur le premier emplacement encore vide */
          var next = chosen.indexOf(null);
          if (next > -1) {
            root.querySelectorAll('.rh-bundle__slot').forEach(function (s) { s.classList.remove('is-active'); });
            var el = root.querySelector('[data-slot="' + next + '"]');
            if (el) el.classList.add('is-active');
          } else {
            root.querySelectorAll('.rh-bundle__slot').forEach(function (s) { s.classList.remove('is-active'); });
          }
        });
      }
      list.appendChild(btn);
    });

    root.querySelectorAll('[data-rh-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        openPicker(parseInt(b.getAttribute('data-rh-pick'), 10));
      });
    });
    root.querySelectorAll('[data-rh-pickclose]').forEach(function (b) {
      b.addEventListener('click', closePicker);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) closePicker(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePicker(); });

    root.querySelectorAll('[data-rh-slotremove]').forEach(function (b) {
      b.addEventListener('click', function () {
        chosen[parseInt(b.getAttribute('data-rh-slotremove'), 10)] = null;
        render();
      });
    });

    /* ajout groupé au panier */
    if (cta) {
      cta.addEventListener('click', function () {
        if (chosen.indexOf(null) > -1) return;

        var label = packLabel();
        var detail = chosen.map(function (c) { return c.title; }).join(' + ');

        var byId = {};
        chosen.forEach(function (c) { byId[c.id] = (byId[c.id] || 0) + 1; });
        var items = Object.keys(byId).map(function (id) {
          return {
            id: Number(id),
            quantity: byId[id],
            properties: { 'Pack': label }
          };
        });

        var old = cta.textContent;
        cta.disabled = true;
        cta.textContent = 'Ajout en cours…';
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Pack': label, 'Composition du pack': detail } })
        })
          .catch(function () { /* l'attribut de panier est un bonus : on continue */ })
          .then(function () {
            return fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function (r) { return r.json(); })
          .then(function () {
            cta.textContent = old;
            chosen = new Array(slotsCount).fill(null);
            render();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function () {
            cta.textContent = old;
            cta.disabled = false;
          });
      });
    }

    var first = root.querySelector('[data-slot="0"]');
    if (first) first.classList.add('is-active');
    render();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-rh-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
